import { ServiceRequestBase } from "../ServiceRequestBase";

export class SendVerificationCodeRequest extends ServiceRequestBase {
    public FirstName: string | null = null;
    public LastName: string | null = null;
    public EmailAddress: string | null = null;
    public Code: string | null = null;
    public IsEmailVerification = false;
}
